<template>
  <div class="ai-section">
    <div class="section-title">
      <b>{{ title }}</b>
    </div>

    <div class="block-explainer">
      <div>
        <strong>What this shows:</strong>
        {{ subtitle }}
      </div>
      <div>
        <strong>Calculation:</strong>
        Answer option volume / total answers × 100.
      </div>
    </div>

    <table class="table ai-table">
      <thead>
      <tr>
        <th>Answer Option</th>
        <th class="text-right">Volume</th>
        <th class="text-right">% of Total</th>
      </tr>
      </thead>

      <tbody>
      <tr
          v-for="answer in items"
          :key="answer.label"
      >
        <td>
          <div class="answer-label">
            {{ answer.label }}
          </div>

          <div class="answer-progress">
            <div
                :class="['answer-progress-fill', answer.class]"
                :style="{ width: answer.percent + '%' }"
            ></div>
          </div>
        </td>

        <td class="text-right">
          {{ formatNumber(answer.volume) }}
        </td>

        <td class="text-right">
          {{ answer.percent }}%
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AnswerOptionsBlock',

  props: {
    title: String,
    subtitle: String,
    items: Array,
    formatNumber: Function
  }
};
</script>

<style scoped>
.ai-section {
  border-top: 1px solid #e1e1e1;
  padding-top: 14px;
  margin-bottom: 22px;
}

.section-title {
  margin-bottom: 12px;
  color: #111;
  font-size: 14px;
  font-weight: 900;
}

.block-explainer {
  background: #f4f9fc;
  border-left: 4px solid #39aa94;
  padding: 10px 12px;
  margin-bottom: 14px;
  color: #333;
  font-size: 12px;
  line-height: 1.45;
}

.block-explainer div {
  margin-bottom: 4px;
}

.block-explainer div:last-child {
  margin-bottom: 0;
}

.ai-table {
  margin-bottom: 0;
  border: 1px solid #e1e1e1;
}

.ai-table thead th {
  background: #fff;
  color: #111;
  font-size: 11px;
  font-weight: 900;
  border-bottom: 1px solid #dcdcdc;
}

.ai-table tbody tr:nth-child(odd) {
  background: #f4f9fc;
}

.ai-table tbody td {
  vertical-align: middle;
  border-top: 1px solid #e1e1e1;
  color: #111;
  font-size: 12px;
}

.answer-label {
  margin-bottom: 5px;
  font-weight: 700;
}

.answer-progress {
  background: #eceff1;
  overflow: hidden;
  height: 5px;
}

.answer-progress-fill {
  height: 5px;
  min-width: 2px;
}

.good {
  background: #39aa94;
}

.warning {
  background: #f0ad4e;
}

.risk {
  background: #f32929;
}
</style>
